import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import scrollToTop from "../assets/scrollToTop";

const StepComponent = (props) => {
    const { step, currentStep } = props;

    const [product, setProduct] = useState({});

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        if(searchParams.get(step.tag))
            if(step.data)
                setProduct(step.data);
            else
                setProduct({})
    }, [searchParams, step.data, step.tag])

    const selectStep = () => {
        scrollToTop();

        searchParams.set('step', step.id);
        setSearchParams(searchParams, { replace: true });
    }

    if(step.tag === 'final') return null;

    return (
        <div onClick={selectStep} className={`step${step.id === currentStep.id ? ' active' : ''}${product.id ? ' done' : ''}`} title={product.id ? product.name : ""}>
            {
                product.id ? 
                    <img className="step-img" src={product.image} alt={step.tag} /> : 
                    <span className={`step-icon ${step.tag}-icon`}></span>
            }
            {step.nombre}
        </div>
    )
}

export default StepComponent;